import { GetterTree } from 'vuex'
import { AuthState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<AuthState, RootState> = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    isNeedChangePassword: state => state.isNeedChangePassword,
    username: state => state.username,
    moderationSettings: state => state.moderationSettings,
    isADUser: state => state.isADUser,
};